<template lang="pug">
  footer.text-xs-center.primary
    span.copyright.mt-5.secondary--text Copyright©2020 Otani Trading,Ltd. All Rights Reserved.
</template>

<script>

export default {
  name: 'CommonFooter',
  mounted: function () {
  },
  data () {
    return {
    }
  }
}

</script>

<style scoped lang="stylus">
//breakpoint
screen-xs = 600px
screen-sm = 960px

breakpoint(bpName)
    for name in bpName
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}

//Footer
footer
  margin-top 100px
  height 130px
  .copyright
    font-size .7rem
    padding-top 50px
    display inline-block
    +breakpoint(xs)
      font-size 0.6rem

</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Footer.vue